import React, { forwardRef } from 'react';
import { MentionsInput, Mention, OnChangeHandlerFunc } from 'react-mentions';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import classNames from './InputArea.module.css';

interface InputAreaProps {
  value: string;
  onChange: OnChangeHandlerFunc;
  data: Record<string, { id: string; display: string }[]>;
  placeholder?: string;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
}

export type Ref = HTMLTextAreaElement;

const InputArea = forwardRef<Ref, InputAreaProps>(
  ({ value, onChange, data, placeholder, setActive }, ref) => {
    const mentionsStyle = {
      backgroundColor: '#e5f6fd',
    };

    return (
      <MentionsInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        inputRef={ref}
        className="mentions-input"
        classNames={classNames}
        onFocus={() => setActive(true)}
        customSuggestionsContainer={(children) => (
          <Card sx={{ p: 1 }}>
            <Stack>{children}</Stack>
          </Card>
        )}
      >
        {Object.keys(data).map((key) => (
          <Mention
            key={key}
            trigger="@"
            data={data[key]}
            markup="{{__display__}}"
            displayTransform={(id, display) => `{{${display}}}`}
            style={mentionsStyle}
            renderSuggestion={(
              suggestion,
              search,
              highlightedDisplay,
              index,
              focused
            ) => (
              <Box
                sx={{
                  p: 1,
                  borderRadius: '5px',
                  outline: (theme) =>
                    focused
                      ? `2px solid ${theme.palette.primary.main}`
                      : undefined,
                }}
              >
                <Typography key={suggestion.id} variant="body1">
                  {suggestion.display}
                </Typography>
              </Box>
            )}
          />
        ))}
      </MentionsInput>
    );
  }
);

export default InputArea;
